export const SelectSuggestTypes = {
    INPUT: 'INPUT',
    SELECT: 'SELECT',
};
